import { render, staticRenderFns } from "./RainJoin.vue?vue&type=template&id=06f93475&scoped=true"
import script from "./RainJoin.vue?vue&type=script&lang=js"
export * from "./RainJoin.vue?vue&type=script&lang=js"
import style0 from "./RainJoin.vue?vue&type=style&index=0&id=06f93475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f93475",
  null
  
)

export default component.exports